import React, { useState, useEffect, useRef } from 'react';
import { Box, Dialog } from '@mui/material';

export default function AspectRatioImage({ src, alt, maxSize = 300 }) {
  const [open, setOpen] = useState(false);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const imgRef = useRef();

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      const ratio = img.width / img.height;
      let width = maxSize;
      let height = maxSize;

      if (ratio > 1) {
        // Landscape
        height = maxSize / ratio;
      } else {
        // Portrait
        width = maxSize * ratio;
      }

      setDimensions({ width, height });
    };
    img.src = src;
  }, [src, maxSize]);

  return (
    <>
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{
          width: dimensions.width,
          height: dimensions.height,
          objectFit: 'contain',
          cursor: 'pointer',
          borderRadius: 1,
        }}
        onClick={() => setOpen(true)}
        ref={imgRef}
      />
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xl">
        <Box
          component="img"
          src={src}
          alt={alt}
          sx={{
            maxWidth: '90vw',
            maxHeight: '90vh',
            objectFit: 'contain',
            display: 'block',
            margin: 'auto',
          }}
        />
      </Dialog>
    </>
  );
}
